import "./index.scss";
import Nav from "../../components/Nav";
import {useEffect, useState} from "react";
import Loader from "../../components/Loader";
import {useGet} from "../../api/request";
import Modal from "../../components/Modal";
import {useAlert} from "../../components/AlertNotification";
import {ActionContext} from "../../context/actionContext";
import {useContext} from "react";
import ReportAloneItem from "../../components/ReportAloneItem";
import TablePagination from "@mui/material/TablePagination";

const Applications = ({type}) => {
    const { action, setAction } = useContext(ActionContext);
    const getU = useGet();
    const alertU = useAlert();

    const [isLoading, setIsLoading] = useState(true);

    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(20);
    const [count, setCount] = useState(0);
    const [applications, setApplications] = useState([]);
    const [searchQuery, setSearchQuery] = useState('')
    const [inputValue, setInputValue] = useState('')
    const [modalStatus, setModalStatus] = useState({
        isActive: false,
        id: 0,
    });
    const [statusesList, setStatusesList] = useState([]);

const handleSearch = (e) => {
    e.preventDefault()
if(inputValue) {
    setSearchQuery(inputValue)
} 
}
    const loadApplications = () => {
        setIsLoading(true);

        let statusKeys = []
        if(type === 'applications') {
           statusKeys = ['not_active', "not_target", 'refuse']
        } 
        if(type === 'leads') {
            statusKeys = ['contact', 'success']
         } if (type === 'clients') {
            statusKeys = ["payment"]
         }
      

        const statusParams = statusKeys.map(key => `status=${key}`).join('&');
  
        let endpoint = `/applications?page=${page + 1}&limit=${limit}`;
        if(statusParams) {
            endpoint += `&${statusParams}`;
        }
     if(searchQuery) {
        if(statusParams) {
            endpoint = `/applications?page=${page + 1}&limit=${limit}&${statusParams}&searchQuery=${searchQuery}`;
        } else {
            endpoint = `/applications?page=${page + 1}&limit=${limit}&searchQuery=${searchQuery}`;
        }
    }

        getU(endpoint)
            .then((resp) => {
                if (resp.status === 'success') {
                    setApplications(resp.data.applications);
                    setCount(resp.data.totalCount);
                }
            })
            .catch(() => {
                setApplications([]);
                setCount(0);
                alertU({
                    status: 'error',
                    title: 'Получение заявок',
                    message: 'Произошла ошибка при попытке получить заявки'
                });
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeLimit = (event) => {
        setLimit(event.target.value);
        setPage(0);
    };


    useEffect(() => {
        getU("applications/statuses")
            .then((response) => {
                if (response.status === "success") {
                    setStatusesList(response.data.statuses);
                }
            })
            .catch(() => {});
    }, []);

    useEffect(() => {
        loadApplications();
    }, [page, limit, searchQuery]);

    useEffect(() => {
        if (action) {
            loadApplications();
            setAction(false);
        }
    }, [action]);


    return (
        <>
            <div className="applications">
                <div className="applications__header">
                    <Nav/>
                </div>
                <form className="applications__search-form">
                    <input 
                        value={inputValue} 
                        onChange={(e) => setInputValue(e.target.value)} 
                        className="applications__search-bar" 
                        placeholder="Поиск заявок по почте, номеру, ссылке или номеру телефона"
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                handleSearch(e);
                            }
                        }}
                    />
                    <button onClick={handleSearch} className="applications__search-btn">
                        <img src="/img/icon_search.svg" alt="search" />
                    </button>
                </form>
             
                <div className="applications__list">
                    {applications?.map((item) => (
                        <ReportAloneItem
                            key={item.id}
                            id={item.id}
                            status={item.status || ''}
                            date={item.creationDate}
                            setModalActive={setModalStatus}
                            modalStatus={modalStatus}
                            allowChangeStatus={item.status !== 'payment'}
                            statusesList={statusesList}
                            link={item.link}
                            email={item.email}
                            phone={item.phone}
                            anotherContact={item.anotherContact}
                            message={item.message}
                            cost={item.cost}
                        />
                    ))}
                    {applications.length === 0 && !isLoading && (
                        <div className="applications__empty-state">
                            Нет данных
                        </div>
                    )}
                    {count > 0 && (
                        <div className="applications__pagination">
                            <TablePagination
                                component="div"
                                labelRowsPerPage={<span>Кол-во эл/стр:</span>}
                                rowsPerPageOptions={[10, 20, 30, 40, 50]}
                                count={count}
                                rowsPerPage={limit}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeLimit}
                            />
                        </div>
                    )}
                </div>

            </div>
            {modalStatus.id !== 0 &&
            <Modal modalStatus={modalStatus} setModalStatus={setModalStatus} onStatusUpdated={loadApplications}/>
            }
            {isLoading && (
                <Loader/>
            )}
        </>
    );
};

export default Applications;
